export class SocialNetwork {

    private active: boolean;
    private centerInternalId: string;
    private centerName: string;
    private contentCode: string;
    private internalId: string;
    private socialName: string;

    constructor(active?: boolean, centerInternalId?: string, centerName?: string, contentCode?: string, internalId?: string, socialName?: string) {
        this.active = active;
        this.centerInternalId = centerInternalId;
        this.centerName = centerName;
        this.contentCode = contentCode;
        this.internalId = internalId;
        this.socialName = socialName;
    }

    public get Active() {
        return this.active;
    }
    public get CenterInternalId() {
        return this.centerInternalId;
    }
    public get CenterName() {
        return this.centerName;
    }
    public get ContentCode() {
        return this.contentCode;
    }
    public get InternalId() {
        return this.internalId;
    }
    public get SocialName() {
        return this.socialName;
    }
    public set Active(active) {
        this.active = active;
    }
    public set CenterInternalId(centerInternalId) {
        this.centerInternalId = centerInternalId;
    }
    public set CenterName(centerName) {
        this.centerName = centerName;
    }
    public set ContentCode(contentCode) {
        this.contentCode = contentCode;
    }
    public set InternalId(internalId) {
        this.internalId = internalId;
    }
    public set SocialName(socialName) {
        this.socialName = socialName;
    }
}
